import { useEffect, type ReactNode } from 'react';
import { useFontSizeStore } from '@/lib/store';

const FONT_SIZES = {
  small: '87.5%',
  medium: '100%',
  large: '112.5%',
} as const;

export function FontSizeProvider({ children }: { children: ReactNode }) {
  const fontSize = useFontSizeStore((s) => s.fontSize);

  useEffect(() => {
    const size = FONT_SIZES[fontSize];
    document.documentElement.style.setProperty('--base-font-size', size);
    document.documentElement.style.fontSize = size;
  }, [fontSize]);

  return <>{children}</>;
}
